import { render, staticRenderFns } from "./otp-verification-modal.vue?vue&type=template&id=11056522&scoped=true"
import script from "./otp-verification-modal.vue?vue&type=script&lang=js"
export * from "./otp-verification-modal.vue?vue&type=script&lang=js"
import style0 from "./otp-verification-modal.vue?vue&type=style&index=0&id=11056522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11056522",
  null
  
)

export default component.exports